var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/System/Alert/20px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    fill: "#FFC000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8944272,1.78885438 L19.2763932,18.5527864 C19.5233825,19.0467649 19.3231581,19.6474379 18.8291796,19.8944272 C18.6903242,19.9638549 18.5372111,20 18.381966,20 L1.61803399,20 C1.06574924,20 0.618033989,19.5522847 0.618033989,19 C0.618033989,18.8447549 0.654179081,18.6916418 0.723606798,18.5527864 L9.10557281,1.78885438 C9.35256206,1.29487588 9.9532351,1.09465154 10.4472136,1.34164079 C10.640741,1.43840449 10.7976635,1.59532698 10.8944272,1.78885438 Z",
    id: "Triangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,7.5 C11.5,6.95 11.05,6.5 10.5,6.5 L9.5,6.501 C8.95,6.501 8.5,6.951 8.5,7.501 L8.502,12.501 C8.502,13.051 8.952,13.501 9.502,13.501 L10.502,13.5 C11.052,13.5 11.502,13.05 11.502,12.5 L11.5,7.5 Z M10.5,7.5 L10.502,12.5 L9.502,12.501 L9.5,7.501 L10.5,7.5 Z",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,15.5 C11.5,14.95 11.05,14.5 10.5,14.5 L9.5,14.501 C8.95,14.501 8.5,14.951 8.5,15.501 L8.502,16.501 C8.502,17.051 8.952,17.501 9.502,17.501 L10.502,17.5 C11.052,17.5 11.502,17.05 11.502,16.5 L11.5,15.5 Z M10.5,15.5 L10.502,16.5 L9.502,16.501 L9.5,15.501 L10.5,15.5 Z",
    id: "Fill-5",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAlert);
export default __webpack_public_path__ + "static/media/system-alert.04b0f6883a4500dc92bfa4ce23d3857b.svg";
export { ForwardRef as ReactComponent };